/* eslint-disable prefer-arrow/prefer-arrow-functions, max-len */

export type Predicate<T> = (item: T) => boolean;
export type Project<T, S> = (item: T) => S;

export interface Range {
  from: number;
  to: number;
}

export function identity<T>(): Project<T, T> {
  return (self) => self;
}

export type ClassType<T> = new (...args: any[]) => T;

export function isTruthy<T>(value: T): boolean {
  return !!value;
}

export function reverseRecord<T extends string | number, S extends string | number>(record: Record<T, S>): Record<S, T> {
  // @ts-ignore
  const result: Record<S, T> = {};

  for (const key of Object.keys(record)) {
    result[record[key]] = key;
  }

  return result;
}

export function throwError(message: string): never {
  throw Error(message);
}

export type MapKeyTypesTo<S, T> = {
  [K in keyof S]: T;
};

export interface Discriminator<T, S extends T> {
  dType: S;
}

export interface TypeDiscriminator<T, S extends T> {
  type: S;
}

// @ts-ignore
// prettier-ignore
export function objectify<S1,                                      K1 extends string>                                                                                                                                                                            (input: readonly [S1],                                      K1: K1):                                                                           { [T in typeof K1]: S1 };
// prettier-ignore
export function objectify<S1, S2,                                  K1 extends string, K2 extends string>                                                                                                                                                         (input: readonly [S1, S2],                                  K1: K1, K2: K2):                                                                   { [T in typeof K1]: S1 } & { [T in typeof K2]: S2 };
// prettier-ignore
export function objectify<S1, S2, S3,                              K1 extends string, K2 extends string, K3 extends string>                                                                                                                                      (input: readonly [S1, S2, S3],                              K1: K1, K2: K2, K3: K3):                                                           { [T in typeof K1]: S1 } & { [T in typeof K2]: S2 } & {[T in typeof K3]: S3};
// prettier-ignore
export function objectify<S1, S2, S3, S4,                          K1 extends string, K2 extends string, K3 extends string, K4 extends string>                                                                                                                   (input: readonly [S1, S2, S3, S4],                          K1: K1, K2: K2, K3: K3, K4: K4):                                                   { [T in typeof K1]: S1 } & { [T in typeof K2]: S2 } & {[T in typeof K3]: S3} & {[T in typeof K4]: S4};
// prettier-ignore
export function objectify<S1, S2, S3, S4, S5,                      K1 extends string, K2 extends string, K3 extends string, K4 extends string, K5 extends string>                                                                                                (input: readonly [S1, S2, S3, S4, S5],                      K1: K1, K2: K2, K3: K3, K4: K4, K5: K5):                                           { [T in typeof K1]: S1 } & { [T in typeof K2]: S2 } & {[T in typeof K3]: S3} & {[T in typeof K4]: S4} & {[T in typeof K5]: S5};
// prettier-ignore
export function objectify<S1, S2, S3, S4, S5, S6,                  K1 extends string, K2 extends string, K3 extends string, K4 extends string, K5 extends string, K6 extends string>                                                                             (input: readonly [S1, S2, S3, S4, S5, S6],                  K1: K1, K2: K2, K3: K3, K4: K4, K5: K5, K6: K6):                                   { [T in typeof K1]: S1 } & { [T in typeof K2]: S2 } & {[T in typeof K3]: S3} & {[T in typeof K4]: S4} & {[T in typeof K5]: S5} & {[T in typeof K6]: S6};
// prettier-ignore
export function objectify<S1, S2, S3, S4, S5, S6, S7,              K1 extends string, K2 extends string, K3 extends string, K4 extends string, K5 extends string, K6 extends string, K7 extends string>                                                          (input: readonly [S1, S2, S3, S4, S5, S6, S7],              K1: K1, K2: K2, K3: K3, K4: K4, K5: K5, K6: K6, K7: K7):                           { [T in typeof K1]: S1 } & { [T in typeof K2]: S2 } & {[T in typeof K3]: S3} & {[T in typeof K4]: S4} & {[T in typeof K5]: S5} & {[T in typeof K6]: S6} & {[T in typeof K7]: S7};
// prettier-ignore
export function objectify<S1, S2, S3, S4, S5, S6, S7, S8,          K1 extends string, K2 extends string, K3 extends string, K4 extends string, K5 extends string, K6 extends string, K7 extends string, K8 extends string>                                       (input: readonly [S1, S2, S3, S4, S5, S6, S7, S8],          K1: K1, K2: K2, K3: K3, K4: K4, K5: K5, K6: K6, K7: K7, K8: K8):                   { [T in typeof K1]: S1 } & { [T in typeof K2]: S2 } & {[T in typeof K3]: S3} & {[T in typeof K4]: S4} & {[T in typeof K5]: S5} & {[T in typeof K6]: S6} & {[T in typeof K7]: S7} & {[T in typeof K8]: S8};
// prettier-ignore
export function objectify<S1, S2, S3, S4, S5, S6, S7, S8, S9,      K1 extends string, K2 extends string, K3 extends string, K4 extends string, K5 extends string, K6 extends string, K7 extends string, K8 extends string, K9 extends string>                    (input: readonly [S1, S2, S3, S4, S5, S6, S7, S8, S9],      K1: K1, K2: K2, K3: K3, K4: K4, K5: K5, K6: K6, K7: K7, K8: K8, K9: K9):           { [T in typeof K1]: S1 } & { [T in typeof K2]: S2 } & {[T in typeof K3]: S3} & {[T in typeof K4]: S4} & {[T in typeof K5]: S5} & {[T in typeof K6]: S6} & {[T in typeof K7]: S7} & {[T in typeof K8]: S8} & {[T in typeof K9]: S9};
// prettier-ignore
export function objectify<S1, S2, S3, S4, S5, S6, S7, S8, S9, S10, K1 extends string, K2 extends string, K3 extends string, K4 extends string, K5 extends string, K6 extends string, K7 extends string, K8 extends string, K9 extends string, K10 extends string>(input: readonly [S1, S2, S3, S4, S5, S6, S7, S8, S9, S10], K1: K1, K2: K2, K3: K3, K4: K4, K5: K5, K6: K6, K7: K7, K8: K8, K9: K9, K10: K10): { [T in typeof K1]: S1 } & { [T in typeof K2]: S2 } & {[T in typeof K3]: S3} & {[T in typeof K4]: S4} & {[T in typeof K5]: S5} & {[T in typeof K6]: S6} & {[T in typeof K7]: S7} & {[T in typeof K8]: S8} & {[T in typeof K9]: S9} & {[T in typeof K10]: S10};
export function objectify(input: any[], ...keys: string[]): Record<string, any> {
  // Soft null check for both null and undefined, then compare the lengths to avoid undefined compare, but allow for 0
  if (input.length == null || input?.length !== keys?.length) {
    throw Error(`Mismatch of argument lengts for arrays [${input}] and [${keys}]`);
  }

  const keySet = new Set(keys);

  if (keySet.size !== keys.length) {
    throw Error('Keys must be unique');
  }

  const ret = {};
  for (const [index, key] of keys.entries()) {
    ret[key] = input[index];
  }

  return ret;
}

export class Sequence {
  private _nextId = 1;

  public get nextId(): number {
    return this._nextId++;
  }
}

export function valuesOfMap<T, S>(map: Map<T, S> | ReadonlyMap<T, S>): S[] {
  const ret: S[] = [];

  for (const value of map.values()) {
    ret.push(value);
  }

  return ret;
}

export function valuesOfRecord<K extends string | number | symbol, T>(record: Record<K, T>): T[] {
  const ret: T[] = [];

  for (const key of Object.keys(record)) {
    ret.push(record[key]);
  }

  return ret;
}

export function logReturn<T>(data: T): T {
  // eslint-disable-next-line no-console
  console.log(data);
  return data;
}

export function mapValuesOfMap<K, V, S>(map: Map<K, V>, project: Project<V, S>): Map<K, S> {
  const ret = new Map<K, S>();

  for (const [key, value] of map.entries()) {
    ret.set(key, project(value));
  }

  return ret;
}

export function mapValuesOfRecord<K extends string | number | symbol, V, S>(record: Record<K, V>, project: Project<V, S>): Record<K, S> {
  // @ts-ignore
  const ret: Record<K, S> = {};

  for (const key of Object.keys(record)) {
    ret[key] = project(record[key]);
  }

  return ret;
}

export function stringKeyMapToRecord<V>(map: Map<string, V>): Record<string, V> {
  const ret: Record<string, V> = {};

  for (const [key, value] of map.entries()) {
    ret[key] = value;
  }

  return ret;
}

export function getMinutesInTimestamp(minutes: number): number {
  return 1000 * 60 * minutes;
}

export function debugTagLog(...data: any[]) {
  const debugTag = '[OSN-DEBUG]';

  // eslint-disable-next-line no-console
  console.log(debugTag, ...data);
}

export function debugLog<T>(message?: string, data?: T) {
  // eslint-disable-next-line no-console
  console.log(`[DEBUG]${message ? `: ${message}` : ''}`, data);
}

export function numberToAdjacentRanges(value: number, maxRangeSize: number, rangeStart: number = 0): Range[] {
  const result: Range[] = [];
  let currentRangeStart = rangeStart;
  while (currentRangeStart < value + rangeStart) {
    result.push({ from: currentRangeStart, to: Math.min(currentRangeStart + maxRangeSize - 1, value) });
    currentRangeStart += maxRangeSize;
  }

  return result;
}

export class Lazy<T> {
  private _value: T;

  constructor(private readonly factory: () => T) {}
  public get(): T {
    if (this._value != null) {
      return this._value;
    }

    this._value = this.factory();
    return this.get();
  }

  public reload() {
    this._value = this.factory();
  }
}

export function create<T>(item: T): T {
  return item;
}
